<template>
    <div class="card-image"
         v-touch:tap="go">
        <div
            style="position: relative;"
            :class="containerClass">
            <div
                class="card-image__wrapper"
                :style="labelColor"
            >
                <div
                    class="shade"
                ></div>
                <b-img
                    v-if="img"
                    :src="img"
                    ref="image"
                    :alt="item.description"
                    class="image"
                    :class="{
                            'landscape': isLandscape,
                            'cover': size && size === 'cover',
                            'contain': size && size ==='contain'
                        }"
                    :blank-color="color"
                    blank-height="300"
                />
                <image-caption
                    :title="captionTitle"
                    :date="captionDate"
                    :type="captionType"
                    :types="captionTypes"
                    :label-color="labelColor"
                />
            </div>
        </div>
    </div>
</template>

<script>

import ImageCardMixin from "../../../mixins/imagecard-mixin"
import ImageCaption from "../Divers/ImageCaption";

export default {
    name: "ImageSlide",
    mixins: [ImageCardMixin],
    components: {
        ImageCaption
    }
}
</script>

